/**
 * @fileoverview POST handler for the "/product_alerts" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { productAlertsIdCacheKeys } from "./constants";
import type { PostProductAlertProps, ProductAlertResultItem, ProductAlertTargetLimitReachedError } from "./types";
import { isProductAlertResultItem } from "./validators";

export const postProductAlert = reactQueryMutationAdapter(
  productAlertsIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<ProductAlertTargetLimitReachedError>()(
    async (props: PostProductAlertProps): Promise<ProductAlertResultItem> => {
      const response = await fetch("/product_alerts", "POST", props, undefined, {
        propagateFetchRequestError: false,
      });

      if (!isProductAlertResultItem(response)) {
        throw new Error("Invalid product alert response");
      }

      return response;
    }
  )
);
